"use client"
import React from 'react'

const ConsentFormPara = () => {
  return (
    <span>
        By entering these details I agree that Amity University Online and its associates can contact me with updates & notifications via Email, SMS, WhatsApp, and Voice call as per its <a id = "privacypolicy-link"
        href="https://amityonline.com/privacy-policy"
        target="_blank" rel="noopener noreferrer"
        style={{textDecoration:'underline',textDecorationColor:'inherit',cursor:'pointer'}}>Privacy Policy</a>. This consent will override any registration for DNC / NDNC.
    </span>
  )
}

export default ConsentFormPara;
